<div>
    <!--------------------------------------------- Header ------------------------------------->
    <div class="flex flex-col w-full relative ">

    </div>
    <!--------------------------------------------- Body ------------------------------------->
    <div class="flex flex-col w-full bg-white dark:bg-gray-800 shadow pt-2 m-2 rounded-xl">
        <div class="flex justify-between items-center gap-2 h-20 p-1  relative overflow-x-auto ">
            <div class="flex items-center gap-2 p-4 ">
                <div class="flex justify-center items-center">
                    <div class="w-6 h-6">
                        <span
                            class="material-icons-outlined text-[20px] text-yellow-500 dark:text-yellow-500 group-hover:text-white transition-colors">
                            receipt_long
                        </span>
                    </div>
                </div>
                <p class="text-yellow-500 text-xl font-bold dark:text-yellow-500" style="width: 180px;">รายการบัตรจอดรถ
                </p>
            </div>
            <div class="flex items-center  space-x-2">
                <div class="flex flex-col pr-2 text-gray-700 dark:text-gray-300">
                    <p class="text-sm">วันที่เริ่มต้น</p>
                    <input type="date" class="bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-200 text-sm rounded-lg
                        focus:ring-blue-500 focus:border-blue-500 block w-full p-2" [(ngModel)]="startDate" />
                </div>
                <div class="flex flex-col pr-2 text-gray-700 dark:text-gray-300">
                    <p class="text-sm">วันที่สิ้นสุด</p>
                    <input type="date" class="bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-200 text-sm rounded-lg
                        focus:ring-blue-500 focus:border-blue-500 block w-full p-2" [(ngModel)]="endDate" />
                </div>
                <div class="flex flex-col pr-2 text-gray-700 dark:text-gray-300">
                    <button
                        class="bg-yellow-300 hover:bg-yellow-200 text-gray-900 mt-4 px-4 py-4 rounded  h-9 flex justify-center items-center"
                        (click)="onSaveSearchByDate()">
                        <div class="flex items-center w-4 h-4">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAExklEQVR4nO2cS49URRSADyaOAsOCEXxsjdGFRBNFQaORBQFNfKC/YwZmp7gyxkQ3wgzo1hB8MokxuiDGEFAjPlgruEGFIOIgs3HBjMT5zEkfSKe9Vff20HPr0fUlvem+qXvqdN1Tp87jihQKhUKhUCgUCoVC4f8Aq4HtwG7gAPA9cBqYAxbsM2fffWfX6LXbgFUVQxauAtwKTAJfmyKXyoKNsUvHvHaDYQd4HPgUuMLg+cfGfkyGFeAJ4Cva40v9U2VYAG4HDgKLhGEGuE1yBnjBNrHQzAE7JDeAEWC6z1V8HngfmDBv4i5gLXCjfdbad/rbTrv2jz7GV1n26liSA8Ao8EXDyc8CU8CD13G/jfanXmx4z89VRkkZ4BbgRIPJngHGgZUDvPdKexrONrj/DyqrpIgeHIBvG7hf08u5okzhrwDzNbKcSG5lm02uMxc/Afe2KNMG4GQDM5KOzbZV6uPDEEdlOkd7de987JEUAJ6p8S7eAm4IKN8K4E2PfCr785LAYcTnJ++TSAD2e+S8FHWcBHi3xlwEW8m9qCw1ZuSARBy7cJmMH2MMX9Lx8U85ZF6MMhjlCRDNt+ld9Atwnycse1RiAnjE8wi+KpEDvO6RP55VbTFf14lvYKe9ZXb7zjnm8IlElBnRE14V45IIdLI7Vejc1scs4GwKq7knZOAKRE1IaCw/V8WUJAawzzGXYzHYNteO/YAkBvCQx3MK93Ra0L2K85IgdI7nFxxz2hpSsJcdQr0niULnBFvFiyGF0sKVODePJWL1IFW8I6GwKqEqtkmiAE865nQ8pFC/OoS6UxKFTsK3il9CCqXhxCrGJO08ZxUXQwrlcu1GJFHopOGqmA8pVI6Kvskxp4WQQuVoOtY55nQppFDDtBmeidG92y6JAjzlmNM3MR5Ydkqi4I5GHgwplLYzVPGBJArwkWNOu0MKpX0mVWhgZoXkFVTaEjpY7nLxNkpiAJs8WZbVsQb+pyUxcBfVHIk52jUbYy1HzdP5V7S5z5rk7EQmydk7JPJyg7MprGo6KbnfHXM4JLGgRSa4eU0iB3gjiQIaxfr4XInNDRIpwP0ezyn8JujogHUVOZ4M7h5VAKwBfnbIrHPZLDFijZouZiIs2/04ubJdRTtSawrR90skAG975NSKpXUSM8DTGbRW7JAUsI5UaszIaCCb7DMX6TQLKdZCrK1kPk5pEXjL3oVr4+vmsKazJLEj7fGGDZ1rllmOJg2d3egiuVkSS91r+28d5yxmsmrACp70nPiyW9mjDcxI926vpbMPLyWebRvdJovCuQJEWStbbfaePl8jccEKDndZmdbd9uqIEfuMAffYb5OWGfmzj/EXTabDWSlbAZ7zlCi0iT45z3bVcWSp7DHbAP8lDDO9PSn2hHyW1QbZE/E7Snsc8cUusl3ZVwEe1RYzT/LgetAxDzUNdWav7K5SLH1jzLE+fd5ertjqHV9KZmQolN3z1pitwEtaaW9vsjltG+mCrVQNXv2mFUQWNdQaky2DCMcOlbJDk/UGGRtF2S1SlN0iRdktUpTdIkXZLVJcv/iUndzbHVJV9t8p1oinqOzLMdWx5KzscE36mSt7yszFZYvPpPXm3pSwnGWxy4VCoVAoFAqFgiwv/wEBcUW0PN9CzwAAAABJRU5ErkJggg=="
                                alt="search--v1">
                        </div>
                    </button>
                </div>
                <div class="w-0.5 h-8 bg-gray-200 mt-4"></div>
                <div class="flex flex-col items-center justify-center pl-1 pr-3">
                    <button (click)="navigateToDetailCreate()"
                        class="bg-green-400 hover:bg-green-300 text-white mt-4 px-5 py-4 rounded  h-9 flex justify-center items-center">
                        <div class="flex items-center w-4 h-4">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA9ElEQVR4nO3RwRGDQAADMfpv2ukgPPcAqQJ79roAAAAOtxv1vtebAK0J0JoArQnQmgCtCdCaAK0J0JoArQnQmgCtCdCaAK0J0JoArQnQmgCtCdCaAK0J0JoArQnQmgCtCdCaAK0J0JoArQnQmgCtCdCaAK0J0JoArQnQ2tcC3B3mPwFiAsQEiAkQEyAmQEyApwc4zb52+DQToDUBWhOgNQFaE6A1AVoToDUBWhOgNQFaE6A1AVoToDUBWhOgNQFaE6A1AVoToDUBWhOgNQFaE6A1AVoToDUBWhOgNQFaE6A1AVoToDUBWhOgNQFaEwAAALie7QcSK+4PTyojTQAAAABJRU5ErkJggg=="
                                alt="plus">
                        </div>
                    </button>
                </div>
            </div>
        </div>
        <div class="w-full h-0.5 bg-gray-200 dark:bg-gray-700 my-2"></div>
        <div class="overflow-x-auto " style="height: 660px;">
            <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                <thead class="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 uppercase text-xs">
                    <tr>
                        <th class="px-4 py-4 text-left">ID</th>
                        <th class="px-4 py-4 text-left">ประเภทบัตร</th>
                        <th class="px-4 py-4 text-left">สถานที่</th>
                        <th class="px-4 py-4 text-left">จำนวน</th>
                        <th class="px-4 py-4 text-left">จำนวนราคา</th>
                        <th class="px-4 py-4 text-left">วันที่เริ่มต้น</th>
                        <th class="px-4 py-4 text-left">วันที่สิ้นสุด</th>
                        <th class="px-4 py-4 text-left">รหัสบิล</th>
                        <th class="px-4 py-4 text-left">รหัสใบแจ้งหนี้</th>
                        <th class="px-4 py-4 text-left">วันที่อนุมัติ</th>
                        <th class="px-4 py-4 text-left">วันที่สร้าง</th>
                        <th class="px-4 py-4 text-left">ภาษีแบบเต็ม</th>
                    </tr>
                </thead>
                <tbody
                    class="divide-y divide-gray-100 dark:divide-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300">
                    <tr *ngFor="let c of paginatedData; " class="hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
                        (click)="navigateToDetailById(c.id)">
                        <td class="px-4 py-4">{{ c.id }}</td>
                        <td class="px-4 py-4">{{ c.cardTypeName }}</td>
                        <td class="px-4 py-4">{{ c.siteName }}</td>
                        <td class="px-4 py-4">{{ c.qty }}</td>
                        <td class="px-4 py-4">{{ c.fee | number: '1.2' }}</td>
                        <td class="px-4 py-4">{{ c.startDate | date: 'dd/MM/yyyy' }}</td>
                        <td class="px-4 py-4">{{ c.endDate | date: 'dd/MM/yyyy' }}</td>
                        <td class="px-4 py-4">{{ c.receiptNo }}</td>
                        <td class="px-4 py-4">{{ c.invoiceNo }}</td>
                        <td class="px-4 py-4">{{ c.approveDate | date: 'dd/MM/yyyy' }}</td>
                        <td class="px-4 py-4">{{ c.createDate | date: 'dd/MM/yyyy' }}</td>
                        <td class="px-4 py-4 flex justify-center">
                            <span [ngClass]="c.fullTax ? 'bg-blue-100 text-blue-700' : 'bg-gray-200 text-gray-600'"
                                class="px-2 py-1 rounded text-xs font-medium ">
                                {{ c.fullTax ? 'มี' : 'ไม่มี' }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- ✅ Pagination controls -->
        <div class="flex items-center justify-between shadow-sm border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
            style="box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.25);">
            <div>
                <button (click)="prevPage()" [disabled]="currentPage === 1" *ngIf="currentPage > 1"
                    class="px-3 py-4 rounded-b bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 text-gray-700 dark:text-gray-300">
                    ย้อนกลับ
                </button>
            </div>

            <span class="text-sm text-gray-700 dark:text-gray-300">
                หน้า {{ currentPage }} จาก {{ totalPages }}
            </span>

            <button (click)="nextPage()" [disabled]="currentPage === totalPages"
                class="px-3 py-4 rounded-b bg-green-400 hover:bg-green-300 disabled:opacity-50 text-white">
                ถัดไป
            </button>
        </div>




    </div>
    <!--------------------------------------------- Footer ------------------------------------->
    <div>

    </div>
</div>


<!--------------------------------------------- Modal ------------------------------------->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>